import { AnimatePresence, motion } from 'framer-motion';
import { useState } from 'react';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const faqItems: FAQItem[] = [
    {
      question: 'What is konnect better?',
      answer:
        'konnect better is a relationship development platform built to help people strengthen their most important relationships in life. We are inspired by years of conversations and coaching with families and leaders. We combine an exclusive community, research-backed content, and practical tools, including an AI-powered coaching app, conversation games, and mastermind groups. Together, our resources can help strengthen communication, deepen trust, and maintain meaningful connections across generations.',
    },
    {
      question: 'How does konnect better work?',
      answer:
        'We offer a range of interactive solutions, including books, courses led by experts, games, and an app, all designed to help you develop essential skills to deepen your relationships and navigate challenges throughout your life journey! Providing thoughtful reflections and practical exercises to implement into everyday interaction.',
    },
    {
      question: 'How does the konnect better app work?',
      answer:
        'The konnect better app serves as your personal psychology coach and learning companion. It uses AI to provide personalized insights, exercises, and guidance based on your goals, preferences, and progress. The app adapts to your needs over time, creating a customized experience for your personal growth journey.',
    },
    {
      question: 'Is my data secure and private?',
      answer:
        'Yes, we take data privacy and security very seriously. All personal information is encrypted and stored securely. We never share your data with third parties without your explicit consent. You can review our privacy policy for more detailed information on how we handle your data.',
    },
    {
      question:
        'Do I need to have relational knowledge to use konnect better products?',
      answer:
        'Not at all! Our products are designed to be accessible to everyone, regardless of their background in psychology. We translate complex psychological concepts into practical, easy-to-understand tools and insights that anyone can benefit from.',
    },
    {
      question: 'Can I use konnect better alongside therapy?',
      answer:
        'Absolutely. konnect better is designed to complement therapy and coaching by offering additional tools  and insights that support  your personal growth both inside and outside of sessions. Please note that konnect better is not a replacement for professional mental health treatment.',
    },
    {
      question: 'How do I join the konnect better community?',
      answer:
        'You can join our community by signing up for our mailing list, downloading the app, or following us on social media. Our community includes access to exclusive content, discussions, and opportunities to connect with others on similar personal growth journeys.',
    },
  ];

  return (
    <section
      id="faq"
      className="section bg-surface dark:bg-panel/90 pb-12 md:pb-16"
    >
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-primary dark:text-theme-primary mb-4">
            FAQ
          </h2>
          <div className="w-24 h-1 bg-secondary mx-auto mb-6"></div>
          {/* <p className="text-lg text-gray-700 dark:text-gray-200 max-w-3xl mx-auto">
            Find answers to common questions about konnect better and our products.
          </p> */}
        </motion.div>

        <div className="max-w-3xl mx-auto">
          {faqItems.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 10 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="mb-4 last:mb-0"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className={`w-full text-left p-5 flex justify-between items-center transition-colors ${
                  activeIndex === index
                    ? 'bg-panel dark:bg-brand-secondary text-brand-primary dark:text-brand-primary rounded-t-lg'
                    : 'bg-card dark:bg-panel/80 text-brand-primary dark:text-theme-primary hover:bg-panel/60 dark:hover:bg-panel/70 rounded-lg'
                }`}
                aria-expanded={activeIndex === index}
              >
                <span className="font-medium text-lg">{item.question}</span>
                {activeIndex === index ? (
                  <FiChevronUp className="flex-shrink-0" />
                ) : (
                  <FiChevronDown className="flex-shrink-0" />
                )}
              </button>
              <AnimatePresence>
                {activeIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: 'auto', opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    className="overflow-hidden"
                  >
                    <div className="p-5 bg-card dark:bg-panel/70 rounded-b-lg text-theme-secondary border-t border-theme">
                      {item.answer}
                    </div>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>

        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mt-12"
        >
          <p className="text-theme-secondary mb-6">
            Still have questions? We're here to help!
          </p>
          <a href="mailto:info@konnectbetter.com" className="btn-secondary inline-block">
            Contact Us
          </a>
        </motion.div> */}
      </div>
    </section>
  );
};

export default FAQSection;
